<script>
    import Fa from 'svelte-fa';
    import { faPlus, faMinus, faTrash } from '@fortawesome/pro-solid-svg-icons';

    import { notification } from '$lib/utils/notifications';

    export let itemQty;
    export let maxQty;
    export let trash;
    export let disabled;
    export let addFunctionToClicks = { minusClick: () => {}, plusClick: () => {} };

    const minQty = trash ? 0 : 1;

    const minusClick = () => {
        if (navigator && 'vibrate' in navigator) {
            navigator?.vibrate(1);
        }
        if (itemQty > minQty) {
            itemQty -= 1;
        }
        addFunctionToClicks.minusClick(itemQty);
    };
    const plusClick = () => {
        if (navigator && 'vibrate' in navigator) {
            navigator?.vibrate(1);
        }
        if (maxQty >= 1 && itemQty <= maxQty + 1) {
            itemQty += 1;
        }
        addFunctionToClicks.plusClick(itemQty);
    };

    $: if (itemQty > maxQty && maxQty > 0) {
        itemQty = maxQty || 1;
        notification(`There is only ${maxQty} available`);
    }
</script>

<div class="relative">
    <button
        class="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-base-700 text-xs"
        on:click={minusClick}
        {disabled}
        aria-label="subtract quantity"
    >
        {#if itemQty <= 1 && trash === true}<Fa icon={faTrash} />{:else}<Fa icon={faMinus} />{/if}
    </button>

    <div class="inline-block w-10 max-w-8 text-center text-base">
        {itemQty}
    </div>

    <button class="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-base-700 text-xs" on:click={plusClick} {disabled} aria-label="add quantity">
        <Fa icon={faPlus} />
    </button>
</div>
